import React, {useEffect} from "react";
import {BotForm, BotRequestPartial} from "./createAndUpdate/BotForm";
import {
    clearUpdateBotState,
    fetchBotToUpdate,
    initialBotLoadingStatusSelector,
    updateBot,
    updateBotErrorMessageSelector,
    updateBotRequestSelector,
    updateBotRequestStatusSelector,
    updateUpdateBotRequest,
} from "../botUpdateSlice";
import {createBotRequestPropertySelector} from "./selector/BotStoreSelector";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {Loader} from "../../../elements/loader/Loader";
import {fetchBotList} from "../botListSlice";
import {RequestStatus} from "../../../../api/apiConfiguration";
import {
    showErrorToastNotification,
    showSuccessToastNotification
} from "../../../elements/toastNotification/toastNotificationSlice";
import {fetchFranchises, franchiseOptionsSelector, franchiseListStatusSelector} from "../../franchise/franchiseSlice";
import {SelectOption} from "../../../elements/select/SelectDropdown";
import {FranchiseRequestUi} from "../franchiseTypes";

interface UpdateBotFormProps {
    publicId: string
    handleClose: () => void
}

export const UpdateBotForm: React.FC<UpdateBotFormProps> = ({publicId, handleClose}) => {

    const dispatch = useAppDispatch();
    const franchises = useAppSelector(franchiseOptionsSelector)
    const updateBotRequestStatus = useAppSelector(updateBotRequestStatusSelector);
    const initialBotLoadingStatus = useAppSelector(initialBotLoadingStatusSelector);
    const franchiseListStatus = useAppSelector(franchiseListStatusSelector)
    const errorMessage = useAppSelector(updateBotErrorMessageSelector);


    useEffect(() => {
        if (initialBotLoadingStatus === RequestStatus.NONE) {
            dispatch(fetchBotToUpdate(publicId))
            dispatch(fetchFranchises())
        }
        return () => {
            dispatch(clearUpdateBotState());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (updateBotRequestStatus === RequestStatus.RESOLVED) {
            dispatch(fetchBotList())
            handleClose()
            dispatch(showSuccessToastNotification({message: "Assistant Updated Successfully"}))
        } else if (updateBotRequestStatus === RequestStatus.REJECTED) {
            dispatch(showErrorToastNotification({message: errorMessage || "Failed to update assistant"}))
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateBotRequestStatus]);


    useEffect(() => {
        if (franchiseListStatus === RequestStatus.REJECTED) {
            // Without franchises the form cannot be filled in, and the render below would otherwise
            // sit on a loader for ever. The thunk has already reported why.
            handleClose()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [franchiseListStatus]);

    if (initialBotLoadingStatus === RequestStatus.RESOLVED &&
        franchiseListStatus === RequestStatus.RESOLVED) {
        const franchiseOptions: SelectOption<FranchiseRequestUi>[] = franchises.map(franchise => ({
            value: franchise,
            label: franchise.name
        }));

        const updateRequest = (update: BotRequestPartial) => {
            dispatch(updateUpdateBotRequest(update))
        }

        const onSubmit = () => {
            dispatch(updateBot())
        }

        return <BotForm
            isUpdateForm={true}
            formTitle={"Update assistant"}
            onClose={handleClose}
            onSubmit={onSubmit}
            updateRequest={updateRequest}
            franchiseOptions={franchiseOptions}
            selectionProvider={createBotRequestPropertySelector(updateBotRequestSelector)}
        />
    } else {
        return <Loader/>
    }
}
